/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MigrateTeamsRequestCto } from '../../models/migrate-teams-request-cto';
import { MigrateTeamsResponseCto } from '../../models/migrate-teams-response-cto';

export interface MigrateTeams$Plain$Params {
      body?: MigrateTeamsRequestCto
}

export function migrateTeams$Plain(http: HttpClient, rootUrl: string, params?: MigrateTeams$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrateTeamsResponseCto>> {
  const rb = new RequestBuilder(rootUrl, migrateTeams$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MigrateTeamsResponseCto>;
    })
  );
}

migrateTeams$Plain.PATH = '/design/team/migrate';
